// extracted by mini-css-extract-plugin
export default {"container":"arc-operators-deleted_page_container__Tvyh9","headerContainer":"arc-operators-deleted_page_headerContainer__gbp2U"};